module.exports = __webpack_public_path__ + "img/ico-right-white.74e24e8b.svg";